<template>
  <div>
    <v-navigation-drawer
      v-model="open"
      :width="$isMobile ? '100%' : '50%'"
      right
      fixed
      :permanent="open"
      hide-overlay
      class="z-index--100">
      <div class="ma-3">
        <div class="d-flex">
          <v-btn
            dark
            fab
            x-small
            outlined
            color="primary"
            class="mr-3"
            @click="closePanel"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <div class="subtitle-1 primary--text my-auto">
            {{ $t('expenses.registerMovements.movements.drawerAdd.title') }}
          </div>
        </div>
        <div>
          <v-row>
            <v-col md="12">
              <v-form v-model="movementForm.isValid" ref="movementForm">
                <v-row>
                  <v-col md="12">
                    <div>{{ $t('expenses.registerMovements.movements.drawerAdd.type') }}</div>
                    <v-btn-toggle
                      v-model="$v.movementForm.type.$model"
                      @change="handleTypeChange"
                      color="primary"
                      group
                      mandatory
                    >
                      <v-btn value="deposit" small class="groupButton">
                        {{ $t('expenses.registerMovements.movements.drawerAdd.deposit') }}
                      </v-btn>
                      <v-btn value="withdrawal" small class="groupButton">
                        {{ $t('expenses.registerMovements.movements.drawerAdd.withdrawal') }}
                      </v-btn>
                      <v-btn value="transfer" small class="groupButton">
                        {{ $t('expenses.registerMovements.movements.drawerAdd.transfer') }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="7">
                    <v-text-field
                      outlined
                      rounded
                      dense
                      v-model.lazy="$v.movementForm.id.$model"
                      :label="$t('expenses.registerMovements.movements.drawerAdd.id')"
                      @input="$v.movementForm.id.$touch()"
                      @blur="$v.movementForm.id.$touch()"
                      :error-messages="idErrors"
                      required
                    />
                  </v-col>
                  <v-col md="7">
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          outlined
                          rounded
                          dense
                          v-model.lazy="$v.movementForm.date.$model"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :label="$t('expenses.registerMovements.movements.drawerAdd.date')"
                          @input="$v.movementForm.date.$touch()"
                          @blur="$v.movementForm.date.$touch()"
                          :error-messages="dateErrors"
                          required
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="primary"
                        value-format="yyyy-MM-dd"
                        type="date"
                        format="yyyy/MM/dd"
                        v-model.lazy="$v.movementForm.date.$model"
                        :allowed-dates="allowedDates"
                        @input="menu = false"
                        :locale="locale"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col md="7" v-if="$v.movementForm.type.$model !== 'deposit'">
                    <v-select
                      outlined
                      rounded
                      dense
                      :item-text="getBankAccountText"
                      item-value="_id"
                      :items="banks.data"
                      :disabled="!banks.data.length"
                      v-model.lazy="$v.movementForm.originBank.$model"
                      :label="$t('expenses.registerMovements.movements.drawerAdd.originBank')"
                      @input="$v.movementForm.originBank.$touch()"
                      @blur="$v.movementForm.originBank.$touch()"
                      :error-messages="originBankErrors"
                      required>
                    </v-select>
                  </v-col>
                  <v-col md="7" v-if="$v.movementForm.type.$model !== 'withdrawal'">
                    <v-select
                      outlined
                      rounded
                      dense
                      :item-text="getBankAccountText"
                      item-value="_id"
                      :items="destinationBanks"
                      :disabled="!destinationBanks.length"
                      v-model.lazy="$v.movementForm.destinationBank.$model"
                      :label="$t('expenses.registerMovements.movements.drawerAdd.destinationBank')"
                      @input="$v.movementForm.destinationBank.$touch()"
                      @blur="$v.movementForm.destinationBank.$touch()"
                      :error-messages="destinationBankErrors"
                      required
                    />
                  </v-col>
                   <v-col md="7" v-if="this.movementForm.type === 'deposit'">
                    <v-select
                      outlined
                      rounded
                      dense
                      item-text="name"
                      item-value="_id"
                      :items="incomeCategories"
                      :label="$t('expenses.registerMovements.movements.drawerAdd.incomeType')"
                      v-model="movementForm.incomeCategory"
                      required>
                    </v-select>
                  </v-col>
                  <v-col md="7" v-if="this.movementForm.type === 'withdrawal'">
                    <v-select
                      outlined
                      rounded
                      dense
                      item-text="name"
                      item-value="_id"
                      v-model="movementForm.outgoingCategory"
                      :items="outgoingCategories"
                      :label="$t('expenses.registerMovements.movements.drawerAdd.outgoingCategory')"
                      required>
                    </v-select>
                  </v-col>
                  <v-col md="7">
                    <v-text-field
                      outlined
                      rounded
                      dense
                      v-model.lazy="$v.movementForm.concept.$model"
                      :label="$t('expenses.registerMovements.movements.drawerAdd.concept')"
                      @input="$v.movementForm.concept.$touch()"
                      @blur="$v.movementForm.concept.$touch()"
                      :error-messages="conceptErrors"
                      required
                    />
                  </v-col>
                  <!-- <v-col md="7">
                    <v-text-field
                      outlined
                      rounded
                      dense
                      v-model.lazy="$v.movementForm.beneficiary.$model"
                      :label="$t('expenses.registerMovements.movements.drawerAdd.beneficiary')"
                      @input="$v.movementForm.beneficiary.$touch()"
                      @blur="$v.movementForm.beneficiary.$touch()"
                      :error-messages="beneficiaryErrors"
                      required
                    />
                  </v-col> -->
                  <v-col md="7">
                    <v-text-field
                      outlined
                      rounded
                      dense
                      type="number"
                      v-model.lazy="$v.movementForm.amount.$model"
                      :label="$t('expenses.registerMovements.movements.drawerAdd.amount')"
                      @input="$v.movementForm.amount.$touch()"
                      @blur="$v.movementForm.amount.$touch()"
                      :error-messages="amountErrors"
                      prefix="$"
                      required
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="12">

                  </v-col>
                </v-row>
              </v-form>
            </v-col>
            <v-col md="12" class="d-flex justify-end">
              <v-btn
                color="primary"
                depressed
                @click="createBankMovement()">
                {{ $t('expenses.registerMovements.movements.drawerAdd.buttonCreate') }}
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-navigation-drawer>

    <v-dialog @keydown.esc="successDialog=false" v-model="successDialog" persistent max-width="400px">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          {{ $t('expenses.registerMovements.movements.drawerAdd.successDialog.text') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" depressed @click="closeSuccessDialog">
            {{ $t('expenses.registerMovements.movements.drawerAdd.successDialog.buttonAccept') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, decimal, minValue } from 'vuelidate/lib/validators'
import getLocale from '@/lang/locale'
import moment from 'moment'

export default {
  name: 'AddBankMovement',
  props: {
    isOpen: Boolean,
    banks: Object,
    selectedBank: String
  },
  mixins: [validationMixin],
  validations: {
    movementForm: {
      type: { required },
      id: { required },
      date: { required },
      originBank: { required },
      destinationBank: { required },
      concept: { required },
      // beneficiary: { required },
      amount: { required, decimal, minValue: minValue(0) }
    }
  },
  data () {
    return {
      overlay: false,
      movementForm: {
        valid: false,
        disabled: false,
        isEditing: false,
        type: null,
        id: null,
        date: null,
        originBank: null,
        destinationBank: null,
        concept: null,
        incomeCategory: null,
        outgoingCategory: null,
        // beneficiary: null,
        amount: null
      },
      incomeCategories: [],
      outgoingCategories: [],
      menu: false,
      successDialog: false
    }
  },
  watch: {
    selectedBank: {
      handler: function () {
        this.movementForm.originBank = this.selectedBank
        this.movementForm.destinationBank = this.selectedBank
      }
    }
  },
  computed: {
    open: {
      get: function () {
        return this.isOpen
      },
      set: function (newValue) {
        this.$emit('update:isOpen', newValue)
      }
    },
    locale () {
      return getLocale(this.$i18n.locale)
    },
    destinationBanks () {
      return this.movementForm.type === 'transfer' ? this.banks.data.filter(item => item._id !== this.selectedBank) : this.banks.data
    },
    idErrors () {
      const errors = []
      if (!this.$v.movementForm.id.$dirty) return errors
      !this.$v.movementForm.id.required && errors.push(this.$i18n.t('expenses.registerMovements.movements.drawerAdd.idErrorsReq'))
      return errors
    },
    dateErrors () {
      const errors = []
      if (!this.$v.movementForm.date.$dirty) return errors
      !this.$v.movementForm.date.required && errors.push(this.$i18n.t('expenses.registerMovements.movements.drawerAdd.dateErrorsReq'))
      return errors
    },
    bankErrors () {
      const errors = []
      if (!this.$v.movementForm.bank.$dirty) return errors
      !this.$v.movementForm.bank.required && errors.push(this.$i18n.t('expenses.registerMovements.movements.drawerAdd.bankErrorsReq'))
      return errors
    },
    originBankErrors () {
      const errors = []
      if (!this.$v.movementForm.originBank.$dirty) return errors
      !this.$v.movementForm.originBank.required && errors.push(this.$i18n.t('expenses.registerMovements.movements.drawerAdd.originBankErrorsReq'))
      return errors
    },
    destinationBankErrors () {
      const errors = []
      if (!this.$v.movementForm.destinationBank.$dirty) return errors
      !this.$v.movementForm.destinationBank.required && errors.push(this.$i18n.t('expenses.registerMovements.movements.drawerAdd.destinationBankErrorsReq'))
      return errors
    },
    conceptErrors () {
      const errors = []
      if (!this.$v.movementForm.concept.$dirty) return errors
      !this.$v.movementForm.concept.required && errors.push(this.$i18n.t('expenses.registerMovements.movements.drawerAdd.conceptErrorsReq'))
      return errors
    },
    // beneficiaryErrors () {
    //   const errors = []
    //   if (!this.$v.movementForm.beneficiary.$dirty) return errors
    //   !this.$v.movementForm.beneficiary.required && errors.push(this.$i18n.t('expenses.registerMovements.movements.drawerAdd.beneficiaryErrorsReq'))
    //   return errors
    // },
    amountErrors () {
      const errors = []
      if (!this.$v.movementForm.amount.$dirty) return errors
      !this.$v.movementForm.amount.minValue && errors.push(this.$i18n.t('expenses.registerMovements.movements.drawerAdd.amountErrorsMin'))
      !this.$v.movementForm.amount.decimal && errors.push(this.$i18n.t('expenses.registerMovements.movements.drawerAdd.amountErrorsDec'))
      !this.$v.movementForm.amount.required && errors.push(this.$i18n.t('expenses.registerMovements.movements.drawerAdd.amountErrorsReq'))
      return errors
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
    this.getOutgoingCategory()
    this.getIncomeCategory()
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') this.closePanel()
    },
    allowedDates (val) {
      const nowDate = new Date()
      const evalDate = new Date(moment(val).format('YYYY-MM-DDTHH:mm:ss.SSS'))

      return evalDate.getTime() <= nowDate.getTime()
    },
    async createBankMovement () {
      this.$v.movementForm.$touch()

      if (!this.$v.movementForm.$invalid) {
        this.overlay = true

        try {
          const payload = {
            type: this.movementForm.type,
            folio: this.movementForm.id,
            date: this.movementForm.date,
            bank: this.movementForm.type === 'deposit' ? this.movementForm.destinationBank : this.movementForm.originBank,
            destinationBank: this.movementForm.type === 'transfer' ? this.movementForm.destinationBank : undefined,
            concept: this.movementForm.concept,
            // beneficiary: this.movementForm.beneficiary,
            amount: this.movementForm.amount,
            incomeType: this.movementForm.incomeCategory || null,
            outgoingCategory: this.movementForm.outgoingCategory || null
          }

          await this.$api.post(`/v1/transfers`, payload)
          this.$emit('updateMovements')
          this.openSuccessDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }

        this.overlay = false
        this.closePanel()
      }
    },
    resetForm () {
      this.movementForm = {
        valid: false,
        disabled: false,
        isEditing: false,
        type: 'deposit',
        id: null,
        date: null,
        bank: this.selectedBank,
        originBank: this.selectedBank,
        destinationBank: this.selectedBank,
        concept: null,
        // beneficiary: null,
        amount: null
      }
      this.$v.$reset()
    },
    openSuccessDialog () {
      this.successDialog = true
    },
    closeSuccessDialog () {
      this.successDialog = false
    },
    closePanel () {
      this.resetForm()
      this.open = false
    },
    getBankAccountText: item => item.name + ' - ' + item.account.name,
    handleTypeChange () {
      if (this.movementForm.type === 'transfer') {
        this.movementForm.destinationBank = null
      } else {
        this.movementForm.destinationBank = this.selectedBank
      }
    },
    async getOutgoingCategory (params = null) {
      params = params || {
        type: 'outgoing',
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/cashflows`, params)
        response.data.map(item => {
          const test = {
            name: item.name,
            _id: item._id
          }
          this.outgoingCategories.push(test)
        })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async getIncomeCategory (params = null) {
      params = params || {
        kind: 'income',
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/cashflows/types`, params)
        response.data.map(item => {
          const test = {
            name: item.name,
            _id: item._id
          }
          this.incomeCategories.push(test)
        })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .groupButton {
    border-style: solid !important;
    border-width: 1px !important;
    border-radius: 30px !important;
    border-color: var(--v-primary-base) !important;
  }
</style>
